/**
 * Which Buy Requests tab a visit lands on. Links state their purpose with `buyRequestsPath()`;
 * the page resolves only through `resolveBuyRequestTab()`, so every entry agrees.
 *  - 'mine'    = the company's own requests (posting, matches to our needs, invites)
 *  - 'matched' = buyers' requests our listings fit (sellers and power traders only)
 * A plain visit with no purpose opens Our requests (the first tab); fresh inbound demand links target 'matched'.
 */
export type BuyRequestTab = 'mine' | 'matched';

export function buyRequestsPath(tab: BuyRequestTab, extra?: Record<string, string>): string {
  const p = new URLSearchParams({ tab, ...(extra ?? {}) });
  return `/buy-requests?${p.toString()}`;
}

/** Top-bar link: new matches on our own requests are the reason to go, so open them. */
export function buyRequestsNavPath(newOwnMatches: number): string {
  return newOwnMatches > 0 ? buyRequestsPath('mine') : '/buy-requests';
}

export function resolveBuyRequestTab(input: {
  canReceive: boolean;
  tab: string | null;
  /** Deep links to one of our own requests (alerts, Next Move, invite suppliers). */
  request?: string | null;
  invite?: string | null;
}): BuyRequestTab {
  if (!input.canReceive) return 'mine';
  if (input.request || input.invite) return 'mine';
  if (input.tab === 'mine' || input.tab === 'matched') return input.tab;
  return 'mine';
}
